export const EMOJI_REGEX =
  /(?:[\u{1F1E6}-\u{1F1FF}]{2}|[#*0-9]\uFE0F?\u20E3|\p{Extended_Pictographic}[\uFE0E\uFE0F]?(?:\p{Emoji_Modifier})?(?:\u200D\p{Extended_Pictographic}[\uFE0E\uFE0F]?(?:\p{Emoji_Modifier})?)*)/gu;

export const SENT_MESSAGE_EMOJI_FONT_SIZE = "1.2em";

export type TextEmojiPart =
  | { type: "text"; value: string }
  | { type: "emoji"; value: string };

export const splitByEmoji = (text: string): TextEmojiPart[] => {
  const parts: TextEmojiPart[] = [];
  const regex = new RegExp(EMOJI_REGEX.source, EMOJI_REGEX.flags);
  let lastIndex = 0;

  for (const match of text.matchAll(regex)) {
    const start = match.index ?? 0;
    if (start > lastIndex) {
      parts.push({ type: "text", value: text.slice(lastIndex, start) });
    }
    parts.push({ type: "emoji", value: match[0] });
    lastIndex = start + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push({ type: "text", value: text.slice(lastIndex) });
  }

  return parts;
};
